<template>
  <div class="box">
    <div
      class="top"
      style="
        background: url(../static/images/cs/e2809b0597463b3c879c0f44dded9a81.jpg);
        background-position-x: center;
        background-position-y: center;
        background-repeat: no-repeat;
      "
    ></div>
    <div class="center">
      <div class="text">
        <p class="title">人才招聘</p>
      </div>
      <div>
        <div class="job">
          <div class="job-title">国际物流销售</div>
          <div class="job-spec">岗位职责：</div>

          <ul class="list">
            <li>
              通过电话拜访、直播、上门拜访、沙龙活动的形式为客户提供专业的咨询，
              跟踪销售产品的整个流程；
            </li>
            <li>为客户提供全链路出口物流的解决方案（各类专线小包，Dhl，Fedex快递）</li>
            <li>开发新客户，维护老客户需求，与客户保持长期的良好关系</li>
            <li>结合客户需求，负责出口物流产品的销售，配合部门领导完成销售任务。</li>
          </ul>

          <div class="job-spec">岗位要求：</div>
          <ul class="list">
            <li>大专及以上学历，有跨境电商服务商相关工作经验优先；</li>
            <li>良好的沟通表达及学习能力；</li>
            <li>具有团队意识，能始终以乐观积极的态度与管理团队保持沟通；</li>
            <li>有客户管理能力，一定的抗压力，自驱力，乐于挑战；</li>
            <li>有一定客户资源的可直接到公司面谈</li>
          </ul>
          <div class="job-spec">工作地址：</div>
          <div>广东省白云区集贤路集安街3号, 凯云商务中心304室7010</div>
          <div>广东省深圳市龙华区清湖路明腾中心大厦15楼1503B</div>
        </div>

        <div class="job">
          <div class="job-title">空运操作员</div>
          <div class="job-spec">岗位职责：</div>
          <ul>
            <li>
              跟踪订单出货情况，了解订单进度，出现问题及时与客户反馈并积极配合解决 问题
            </li>
            <li>负责日常空运操作工作，例如：订舱、做提单、货物跟踪等</li>
            <li>及时跟踪和反馈货物的起飞日期</li>
            <li>制作空运单证及其相关文件文件的整理和归档等</li>
            <li>订单信息资料录入系统</li>
          </ul>
          <div class="job-spec">任职要求：</div>
          <ul>
            <li>
              大专及以上学历，工作经验1年以上，欢迎国际贸易、国际物流或英语
              相关专业的优秀毕业生加盟；
            </li>
            <li>外贸专业与商务英文专业者优；</li>
            <li>要有坚强的责任感，团队意识与集体荣誉感。</li>
          </ul>
          <div class="job-spec">工作地址：</div>
          <div>广东省白云区集贤路集安街3号, 凯云商务中心304室</div>
        </div>

        <div class="job">
          <div class="job-title">物流操作员</div>
          <div class="job-spec">工作内容：</div>
          <ul>
            <li>物流收发货、分拣货、打包、装卸、仓库日常整理等工作，轻小件为主</li>
            <li>熟悉物流分拣、电脑基本操作、物流扫描者优先</li>
          </ul>
          <div class="job-spec">岗位要求：</div>
          <ul>
            <li>20岁-40岁，有做过物流或者仓库工作者优先</li>
            <li>做事仔细认真、能吃苦耐劳，能适应加班，服从管理</li>
            <li>熟悉物流分拣，物流扫描者优先；（有物流公司或货代公司从业经验者优先）</li>
          </ul>
          <div class="job-spec">工作地址：</div>
          <div>广州市番禺区永善村永峰路23号9栋之二</div>
        </div>
      </div>
      <div class="contact">
        <div class="aboutus">
          <p><span>联系人：</span>段先生 / 肖先生</p>
          <p><span>联系电话：</span>15920931685 / 17727637616</p>
          <p><span>邮箱：</span>duanyixiang@xingyunyi.cn / xiaobowei@xingyunyi.cn</p>
          <p><span>地址：</span>广东省白云区集贤路集安街3号, 凯云商务中心304室</p>
        </div>
        <img src="@/images/qr.png" class="qrcode" />
      </div>
    </div>
  </div>
</template>
<style scoped>
ul {
  list-style-type: decimal;
}
.contact {
  display: flex;
  justify-content: space-between;
}
.contact .qrcode {
  width: 200px;
}
.job {
  margin: 50px 0;
  padding-bottom: 50px;
  border-bottom: 1px dashed #ccc;
}
.job-title {
  margin: 20px 0;
  font-weight: bold;
  font-size: 18px;
}
.job-spec {
  margin: 10px 0;
  font-weight: bold;
}
.top {
  width: 100%;
  height: 200px;
}

.center {
  width: 1300px;
  box-sizing: border-box;
  padding: 50px 50px 100px 50px;
  min-height: 800px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: -40px;
  color: #4b4b4b;
}

.text p {
  padding: 30px 0;
  padding-top: 0;
  border-bottom: 1px solid #939393;
  margin: 0;
}
.aboutus p span {
  width: 100px;
  display: inline-block;
  text-align: left;
}
.text .title {
  font-weight: 800;
  font-size: 36px;
}

.aboutus {
  font-size: 18px;
  line-height: 30px;
}
</style>
<script>
export default {
  data () {
    return {
      dto: {}
    }
  },
  name: 'recruit'
}
</script>



// WEBPACK FOOTER //
// src/components/recruit.vue